<template>
  <div id="app">
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
    <simple-tahsilat-odeme-dialog
  ref="simpleTahsilatOdemeDialog"
  @saved="CarihareketGetir">
</simple-tahsilat-odeme-dialog>

    <receipt-pdf-settings-dialog
      ref="receiptPdfSettingsDialog">
    </receipt-pdf-settings-dialog>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">
              {{ $t('Collections-and-Payments') }}
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-text-field
              flat
              solo-inverted
              hide-details
              v-model="search"
              :label="$t('Search')"
              append-icon="search">
            </v-text-field>

            <v-tooltip bottom>
              <v-btn
                slot="activator"
                @click="openEntryDialog('TAHSILAT')"
                flat>
                <span class="hidden-sm-and-down">{{ $t('New-Transaction') }}</span>
                <v-icon right dark>add_box</v-icon>
              </v-btn>
              <span>{{ $t('Collection-Payment-Entry') }}</span>
            </v-tooltip>


            <v-menu bottom left offset-y>
              <v-btn
                slot="activator"
                icon
                flat
                dark>
                <v-icon>more_vert</v-icon>
              </v-btn>

              <v-list>
                <v-list-tile @click="openReceiptPdfSettings">
                  <v-list-tile-action>
                    <v-icon color="info">picture_as_pdf</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title>
                      PDF Logo ve Alt Bilgi Ayarları
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>

        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12 sm4 md2>
              <tarihim
                :etiket="$t('Starting-Date')"
                :detaygizle="false"
                v-model="date"
                v-bind:defaultvalue="'ok'"
                :rules="[v => !!v || $t('Please-select-a-date')]">
              </tarihim>
            </v-flex>

            <v-flex xs12 sm4 md2>
              <tarihim
                :etiket="$t('Finishing-Date')"
                :detaygizle="false"
                v-model="date2"
                v-bind:defaultvalue="'ok'"
                :rules="[v => !!v || $t('Please-select-a-date')]">
              </tarihim>
            </v-flex>

            <v-flex xs12 sm4 md2>
              <v-select
                hide-details
                :items="operationFilterItems"
                item-text="text"
                item-value="value"
                v-model="operationFilter"
                :label="$t('Transaction-Type')">
              </v-select>
            </v-flex>

            <v-flex xs12 sm4 md2>
              <v-select
                hide-details
                :items="paymentMethodFilterItems"
                item-text="text"
                item-value="value"
                v-model="paymentMethodFilter"
                :label="$t('Payment-Method')">
              </v-select>
            </v-flex>

            <v-flex>
              <v-layout>
                <div v-if="load1">
                  <v-btn color="info" @click="CarihareketGetir()" fab small dark>
                    <v-icon>search</v-icon>
                  </v-btn>
                </div>

                <div v-if="!load1">
                  <v-layout align-center fill-height>
                    <v-progress-circular indeterminate color="info"></v-progress-circular>
                  </v-layout>
                </div>

                <v-badge color="white" :overlap="true">
                  <template v-slot:badge>
                    <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                  </template>

                  <v-btn
                    small
                    @mouseenter="tooltip = true"
                    @mouseleave="tooltip = false"
                    ref="fab"
                    @click.native="dialogfiltre = true"
                    color="info"
                    fab
                    dark>
                    <v-icon>filter_list</v-icon>
                  </v-btn>

                  <v-tooltip bottom :activator="el" v-model="tooltip">
                    <span>{{ $t('Add-Search-Filter') }}</span>
                  </v-tooltip>
                </v-badge>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <v-card flat color="grey lighten-5">
                <v-flex v-show="filteredItems.length > 0" xs12 sm12 md12>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md9>
                      <v-layout align-center fill-height>
                        <div class="font-weight-large grey--text title">
                          &nbsp; {{ filteredItems.length }} {{ $t('record') }}
                        </div>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md12>
                  <v-data-table
                    :headers="headers"
                    :loading="progress"
                    :rows-per-page-items="[50, 100]"
                    :items="filteredItems"
                    :search="search">

                    <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                    <template slot="items" slot-scope="props">
                      <tr>
                        <td class="text-xs-left">
                          <v-chip
                            small
                            :color="props.item.BA == 'A' ? 'green' : 'red'"
                            text-color="white">
                            {{ getBAName(props.item.BA) }}
                          </v-chip>
                        </td>

                        <td class="text-xs-left">
                          {{ props.item.Cari && props.item.Cari.Kod ? props.item.Cari.Kod : '' }}
                        </td>

                        <td class="text-xs-left">
                          {{ props.item.Cari && props.item.Cari.Unvan ? props.item.Cari.Unvan : '' }}
                        </td>

                        <td class="text-xs-left">
                          {{ props.item.Tarih | dateformat }}
                        </td>

                        <td class="text-xs-left">
                          {{ props.item.Evrak && props.item.Evrak.Evrakkod ? props.item.Evrak.Evrakkod : '' }}
                        </td>

                        <td class="text-xs-left">
                          {{ props.item.Evrakno }}
                        </td>

                        <td class="text-xs-left">
                          {{ getPaymentMethodNameFromRow(props.item) }}
                        </td>

                        <td class="text-xs-right">
                          {{ props.item.Tutar | moneyformat }}{{ getparabirimi() }}
                        </td>

                        <td class="text-xs-left">
                          {{ props.item.Aciklama }}
                        </td>

                        <td class="text-xs-left">
                          {{ props.item.Faturano }}
                        </td>

                        <td class="text-xs-left action-cell">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              small
                              icon
                              flat
                              @click.stop="downloadReceiptPdfFromRow(props.item)">
                              <v-icon color="info">picture_as_pdf</v-icon>
                            </v-btn>
                            <span>{{ $t('Download-Receipt-Pdf') }}</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              small
                              icon
                              flat
                             @click.stop="openTahsilatOdemeEdit(props.item)">
                              <v-icon color="info">edit</v-icon>
                            </v-btn>
                            <span>{{ $t('Edit') }}</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              small
                              icon
                              flat
                              @click.stop="openChangeLog(props.item)">
                              <v-icon color="info">info</v-icon>
                            </v-btn>
                            <span>{{ $t('Log-Records') }}</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </template>

                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                      {{ $t('No-records-searched-for', { value: search }) }}
                    </v-alert>
                  </v-data-table>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
    </v-card>

    <!-- Filtre Dialog -->
    <v-dialog v-model="dialogfiltre" scrollable persistent max-width="420px">
      <v-card color="grey lighten-5">
        <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-flex mt-2 xs12 sm12 md12>
            <v-card flat>
              <v-card-actions>
                <v-layout row wrap>
                  <div class="flex md12">
                    <cariaracomp
                      v-bind:etiket="$t('Current-Account')"
                      v-bind:value="CariHareketInput.CariKodu"
                      v-model="CariHareketInput.CariKodu">
                    </cariaracomp>

                    <v-layout>
                      <v-flex xs12 sm6 md6>
                        <parainput
                          :simge="getparabirimi()"
                          v-model="CariHareketInput.Filtreler.BaslangicTutar"
                          :etiket="$t('Amount-Commencement')"
                          :autocomplete="'autocomplete'">
                        </parainput>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <parainput
                          :simge="getparabirimi()"
                          :detaygizle="'true'"
                          v-model="CariHareketInput.Filtreler.BitisTutar"
                          :etiket="$t('Amount-Completion')"
                          :autocomplete="'autocomplete'">
                        </parainput>
                      </v-flex>
                    </v-layout>

                    <v-autocomplete
                      hide-details
                      :items="evraktipi"
                      v-model="CariHareketInput.Filtreler.EvrakTipi"
                      :label="$t('Document-Type')"
                      item-text="Title"
                      item-value="Evrakkod">
                    </v-autocomplete>

                    <v-text-field
                      hide-details
                      v-model="CariHareketInput.Filtreler.EvrakNo"
                      :label="$t('Document-No')">
                    </v-text-field>

                    <v-text-field
                      hide-details
                      v-model="CariHareketInput.Filtreler.FaturaNo"
                      :label="$t('Invoice-No')">
                    </v-text-field>
                  </div>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="filtreiptal()">
            {{ $t('cancel_button') }}
          </v-btn>
          <v-btn color="blue darken-1" flat @click="filtrekayit()">
            {{ $t('Apply-Filters') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Makbuz PDF Dil Seçim Dialogu -->
<v-dialog
  v-model="receiptLanguageDialog"
  persistent
  max-width="420px">

  <v-card>
    <v-card-title class="headline">
      {{ $t('Language-select') }}
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text>
      <v-select
        v-model="receiptLanguage"
        :items="receiptLanguageItems"
        item-text="text"
        item-value="value"
        label="PDF Dili"
        prepend-icon="language"
        hide-details>
      </v-select>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn
        flat
        color="grey darken-1"
        @click="cancelReceiptLanguageDialog">
        {{ $t('cancel_button') }}
      </v-btn>

      <v-btn
        flat
        color="info"
        :loading="progress"
        @click="confirmReceiptPdfDownload">
        {{ $t('Download-Receipt-Pdf') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

    <!-- Log Dialog -->
    <v-dialog v-model="logDialog" max-width="850px">
      <v-card>
        <v-card-title class="headline">
          {{ $t('Log-Records') }}
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>
          <div v-if="changeLogs && changeLogs.IlkKayitTarihi">
            <strong>İlk Kayıt:</strong>
            {{ changeLogs.IlkKayitTarihi | dateformat }} - {{ changeLogs.IlkKaydeden }}
          </div>

          <v-divider class="my-3"></v-divider>

          <div v-if="changeLogs && changeLogs.Degisiklikler && changeLogs.Degisiklikler.length > 0">
            <v-card
              v-for="(log, index) in changeLogs.Degisiklikler"
              :key="index"
              class="mb-3"
              flat
              color="grey lighten-4">
              <v-card-title>
                <strong>#{{ index + 1 }} - Değişiklik</strong>
                <v-spacer></v-spacer>
                <v-chip small color="info" text-color="white">
                  {{ log.Kullanici || 'Bilinmiyor' }}
                </v-chip>
              </v-card-title>

              <v-card-text>
                <v-data-table
                  :headers="logHeaders"
                  :items="log.Degisiklikler || []"
                  hide-actions>
                  <template slot="items" slot-scope="props">
                    <td>{{ props.item.AlanAdi }}</td>
                    <td>{{ props.item.EskiDeger || '-' }}</td>
                    <td>{{ props.item.YeniDeger || '-' }}</td>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </div>

          <div v-else>
            Log kaydı bulunamadı.
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="logDialog = false">
            {{ $t('Close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      :timeout="timeout"
      :top="y === 'top'"
      :bottom="y === 'bottom'"
      :right="x === 'right'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      v-model="snackbar">
      {{ text1 }}
      <v-btn flat color="pink" @click.native="snackbar = false">
        {{ $t('Close') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import auth from '../../../api/auth'
import parainput from '../customcomp/parainput'
import tarihim from '../customcomp/tarihim'
import helpers from '@/components/app/customcomp/helpers.js'
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
import snackbarcomp from '@/components/app/customcomp/snackbarcomp'
import bankakodu from '@/components/app/customcomp/bankakodu'
import kredikartcomp from '@/components/app/bilet/partpage/kredikartcomp.vue'
import masrafmerkezicomp from '@/components/app/bilet/partpage/masrafmerkezicomp.vue'
import referansmerkezicomp from '@/components/app/bilet/partpage/referanscomp.vue'
import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp.vue'
import SimpleTahsilatOdemeDialog from '@/components/app/coper/component/SimpleTahsilatOdemeDialog.vue'
import ReceiptPdfSettingsDialog from '@/components/app/coper/component/ReceiptPdfSettingsDialog.vue'

export default {
  data() {
    return {
      simpleMode: false,

      search: '',
      date: null,
      date2: null,
      load1: true,
      load: false,
      progress: false,
      filtrevarmi: false,
      tooltip: false,
      el: null,
      dialogfiltre: false,

      receiptLanguageDialog: false,
receiptLanguage: 'tr',
pendingReceiptPdfParams: null,
pendingReceiptBa: null,

receiptLanguageItems: [
  {
    text: 'Türkçe',
    value: 'tr'
  },
  {
    text: 'English',
    value: 'en'
  },
  {
    text: 'Deutsch',
    value: 'de'
  },
  {
    text: 'Français',
    value: 'fr'
  }
],

      operationFilter: 'ALL',
      paymentMethodFilter: 'ALL',

      rawItems: [],
      evraktipi: [],
      doviztipi: [],
      bankapositems: [],

      entryDialog: false,
      entryValid: true,
      saveLoading: false,
      operationType: 'TAHSILAT',
      paymentMethod: 'CASH',
      extraOptionsOpen: false,

      Movement: this.getDefaultMovement(),

      CariHareketInput: {
        SirketKodu: null,
        BaslangicTarihi: null,
        BiletHaric: false,
        BitisTarihi: null,
        CariKodu: null,
        Filtreler: {
          Referans: null,
          Masraf: null,
          BaslangicTutar: 0,
          BitisTutar: 0,
          EvrakNo: null,
          EvrakTipi: null,
          FaturaNo: null
        },
        Entegre: false,
        ListTipi: 0
      },

      headers: [
        {
          text: this.$t('Transaction-Type'),
          value: 'BA'
        },
        {
          text: this.$t('Account'),
          value: 'Cari.Kod'
        },
        {
          text: this.$t('Title_label'),
          value: 'Cari.Unvan'
        },
        {
          text: this.$t('Date'),
          value: 'Tarih'
        },
        {
          text: this.$t('Document-Type'),
          value: 'Evrak.Evrakkod'
        },
        {
          text: this.$t('Document-No'),
          value: 'Evrakno'
        },
        {
          text: this.$t('Payment-Method'),
          value: 'PaymentMethod'
        },
        {
          text: this.$t('Amount'),
          value: 'Tutar',
          align: 'right'
        },
        {
          text: this.$t('Description'),
          value: 'Aciklama'
        },
        {
          text: this.$t('Invoice-No'),
          value: 'Faturano'
        },
        {
          text: this.$t('Transactions'),
          value: 'actions',
          sortable: false
        }
      ],

      operationFilterItems: [
        {
          text: this.$t('All'),
          value: 'ALL'
        },
        {
          text: this.$t('Collection-v3'),
          value: 'TAHSILAT'
        },
        {
          text: this.$t('Payment-v3'),
          value: 'ODEME'
        }
      ],

      paymentMethodFilterItems: [
        {
          text: this.$t('All'),
          value: 'ALL'
        },
        {
          text: this.$t('Cash-v2'),
          value: 'CASH'
        },
        {
          text: this.$t('Bank-v2'),
          value: 'BANK'
        },
        {
          text: this.$t('Credit-Card-v2'),
          value: 'CARD'
        }
      ],

      logDialog: false,
      changeLogs: null,
      logHeaders: [
        {
          text: 'Alan',
          value: 'AlanAdi'
        },
        {
          text: 'Eski Değer',
          value: 'EskiDeger'
        },
        {
          text: 'Yeni Değer',
          value: 'YeniDeger'
        }
      ],

      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      text1: ''
    }
  },

  computed: {
    filteredItems() {
      var list = this.rawItems || []

      list = list.filter(x => this.isTahsilatOdemeRow(x))

      if (this.operationFilter == 'TAHSILAT') {
        list = list.filter(x => x.BA == 'A')
      }

      if (this.operationFilter == 'ODEME') {
        list = list.filter(x => x.BA == 'B')
      }

      if (this.paymentMethodFilter != 'ALL') {
        list = list.filter(x => this.getPaymentMethodValueFromRow(x) == this.paymentMethodFilter)
      }

      return list
    }
  },

  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t)
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m)
    }
  },

  methods: {
    getDefaultMovement() {
      return {
        Current: '',
        MovementDate: null,
        MovementDueDate: null,
        DocumentType: '',
        DocumentNumber: '',
        Explanation: '',
        DebitCredit: '',
        Amount: 0,
        ExchangeType: '',
        ExchangeRate: 1,
        ExchangeAmount: 0,
        ContraDocumentType: '',
        ContraDocumentNumber: '',
        ContraCurrent: 0,
        ContraExplanation: '',
        ContraExchangeType: '',
        ContraExchangeRate: 0,
        ContraExchangeAmount: 0,
        PaymentCode: '',
        Reference: '',
        ExpenseCenter: null,
        CompanyCode: '',
        ReceiptType: '',
        FirmCardNumber: null,
        CardNumber: null,
        PosCode: null,
        InstallmentID: null,
        InstallmentExplanation: null,
        GrossAmount: 0,
        TaxAmount: 0,
        DiscountAmount: 0,
        ContraAccount: null,
        BankCode: null,
        AccountingIntegration: true
      }
    },
openTahsilatOdemeEdit(item) {
  if (!item || !item.Cari || !item.Cari.Kod || !item.Tarih || !item.Sirano) {
    this.text1 = 'Düzenleme için cari kodu, tarih ve sıra no bilgisi gerekli.'
    this.snackbar = true
    return
  }

  var referenceValue = ''

  if (item.Referans && item.Referans.Kod) {
    referenceValue = item.Referans.Kod
  } else if (item.Reference) {
    referenceValue = item.Reference
  }

  var expenseCenterValue = null

  if (item.Masraf && item.Masraf.Code) {
    expenseCenterValue = item.Masraf.Code
  } else if (item.Masraf && item.Masraf.Kod) {
    expenseCenterValue = item.Masraf.Kod
  } else if (item.ExpenseCenter) {
    expenseCenterValue = item.ExpenseCenter
  }

  this.$refs.simpleTahsilatOdemeDialog.open({
    isEditMode: true,

    orderNumber: item.Sirano,
    oldOrderNumber: item.Sirano,
    oldCurrent: item.Cari.Kod,
    oldMovementDate: item.Tarih,

    operationType: item.BA == 'A' ? 'TAHSILAT' : 'ODEME',
    paymentMethod: this.getPaymentMethodValueFromRow(item) || 'CASH',

    currentCode: item.Cari.Kod,
    amount: item.Tutar || 0,
    date: item.Tarih,
    dueDate: item.Vade || item.Tarih,

    documentType: this.getEvrakKod(item),
    documentNumber: item.Evrakno || '',

    explanation: item.Aciklama || '',
    reference: referenceValue,
    expenseCenter: expenseCenterValue,
    accountingCode: item.KarsiHesap || null,

    exchangeType: item.DovizCinsi || '',
    exchangeRate: item.Kur || 1,
    exchangeAmount: item.DovizTutar || item.Tutar || 0,

    bankCode: item.BankaKod || item.BankCode || null,
    posCode: item.PosKod || item.PosCode || null,
    firmCardNumber: item.FirmaKart || item.KrediKartNo || null
  })
},
    simpleModeYukle() {
      var manageload = null

      try {
        manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'))
      } catch (e) {
        manageload = null
      }

      if (manageload && manageload.UserInfo) {
        this.simpleMode =
          manageload.UserInfo.SimpleMode === true ||
          manageload.UserInfo.SimpleMode === 1 ||
          manageload.UserInfo.SimpleMode === '1' ||
          manageload.UserInfo.SimpleMode === 'true'
      }
    },

    selectPaymentMethod(method) {
      this.paymentMethod = method
      this.paymentMethodChanged()
    },

    modernPaymentClass(method) {
      return {
        'modern-payment-method-card': true,
        'modern-payment-method-card-active': this.paymentMethod == method
      }
    },

    modernOperationClass(type) {
      return {
        'modern-operation-item': true,
        'modern-operation-item-active': this.operationType == type
      }
    },

    getDateNow() {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }

      if (mm < 10) {
        mm = '0' + mm
      }

      return yyyy + '-' + mm + '-' + dd
    },

    getparabirimi() {
      return helpers.getparabirimi()
    },

    getCurrentCode(current) {
      if (current == null) {
        return ''
      }

      if (typeof current == 'object') {
        return current.Kod || current.id || current.Id || current.CariKodu || ''
      }

      return current
    },

    getBAName(ba) {
      if (ba == 'A') {
        return this.$t('Collection-v3')
      }

      if (ba == 'B') {
        return this.$t('Payment-v3')
      }

      return ba
    },

    isTahsilatOdemeRow(item) {
      if (!item) {
        return false
      }

      var receiptType = item.MakbuzTip || item.ReceiptType || item.MakbuzTipi || item.Makbuztip

      if (receiptType == 1 || receiptType == '1' || receiptType == 2 || receiptType == '2') {
        return true
      }

      var evrakKod = this.getEvrakKod(item)
      var odemeEvraklari = ['NK', 'HV', 'KK', 'POS', 'KART', 'CC']

      if (odemeEvraklari.indexOf(evrakKod) > -1) {
        return true
      }

      return false
    },

    getEvrakKod(item) {
      if (!item) {
        return ''
      }

      if (item.Evrak && item.Evrak.Evrakkod) {
        return item.Evrak.Evrakkod
      }

      return item.EvrakKod || item.DocumentType || ''
    },

    getPaymentMethodValueFromRow(item) {
      var evrakKod = this.getEvrakKod(item)

      if (evrakKod == 'NK') {
        return 'CASH'
      }

      if (evrakKod == 'HV') {
        return 'BANK'
      }

      if (evrakKod == 'KK' || evrakKod == 'POS' || evrakKod == 'KART' || evrakKod == 'CC') {
        return 'CARD'
      }

      if (item && item.BankCode) {
        return 'BANK'
      }

      if (item && (item.PosCode || item.FirmCardNumber)) {
        return 'CARD'
      }

      return ''
    },

    getPaymentMethodNameFromRow(item) {
      var value = this.getPaymentMethodValueFromRow(item)

      if (value == 'CASH') {
        return this.$t('Cash-v2')
      }

      if (value == 'BANK') {
        return this.$t('Bank-v2')
      }

      if (value == 'CARD') {
        return this.$t('Credit-Card-v2')
      }

      return '-'
    },

    openReceiptPdfSettings() {
      if (
        this.$refs.receiptPdfSettingsDialog &&
        typeof this.$refs.receiptPdfSettingsDialog.open === 'function'
      ) {
        this.$refs.receiptPdfSettingsDialog.open()
      } else {
        this.text1 = 'PDF logo ve alt bilgi ayarları açılamadı.'
        this.snackbar = true
      }
    },

    openEntryDialog(type) {
  this.$refs.simpleTahsilatOdemeDialog.open({
    isEditMode: false,
    operationType: type || 'TAHSILAT'
  })
},

    closeEntryDialog() {
      this.entryDialog = false
      this.saveLoading = false
      this.Movement = this.getDefaultMovement()
    },

    operationTypeChanged() {
      if (this.operationType == 'TAHSILAT') {
        this.Movement.DebitCredit = 'A'
        this.Movement.ReceiptType = '1'
      } else {
        this.Movement.DebitCredit = 'B'
        this.Movement.ReceiptType = '2'
      }

      this.Movement.DocumentNumber = null
    },

    paymentMethodChanged() {
      if (this.paymentMethod == 'CASH') {
        this.Movement.DocumentType = this.findDocumentType(['NK'], 'NK')
      }

      if (this.paymentMethod == 'BANK') {
        this.Movement.DocumentType = this.findDocumentType(['HV'], 'HV')
      }

      if (this.paymentMethod == 'CARD') {
        this.Movement.DocumentType = this.findDocumentType(['KK', 'POS', 'KART', 'CC'], 'KK')
      }

      if (this.paymentMethod != 'BANK') {
        this.Movement.BankCode = null
      }

      if (this.paymentMethod != 'CARD') {
        this.Movement.PosCode = null
        this.Movement.FirmCardNumber = null
        this.Movement.CardNumber = null
      }

      this.Movement.DocumentNumber = null
    },

    findDocumentType(codes, fallback) {
      if (!this.evraktipi || this.evraktipi.length == 0) {
        return fallback
      }

      for (var i = 0; i < codes.length; i++) {
        var code = codes[i]
        var found = this.evraktipi.find(x => x.Evrakkod == code)

        if (found) {
          return found.Evrakkod
        }
      }

      return fallback
    },

    exchangeAmountCalculate() {
      var amount = Number(this.Movement.Amount || 0)
      var rate = Number(this.Movement.ExchangeRate || 1)

      if (rate == 0) {
        rate = 1
      }

      this.Movement.ExchangeAmount = amount * rate
    },

    kurgetir(kod) {
      if (kod == null || kod == '') {
        return
      }

      var params = {
        Tarih: this.Movement.MovementDate,
        DovizKod: kod
      }

      this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params, {
        headers: auth.getAuthCompaniesInfo()
      }).then((response) => {
        if (response.body == 0.0) {
          this.Movement.ExchangeRate = 1
        } else {
          this.Movement.ExchangeRate = response.body
        }

        this.exchangeAmountCalculate()
      }, () => {
        this.text1 = 'Service Unavailable-Kur Hesapla'
        this.snackbar = true
      })
    },

    saveEntry(downloadAfterSave) {
      if (!this.$refs.entryForm.validate()) {
        return
      }

      var credentials = JSON.parse(window.localStorage.getItem('credentials'))
      var currentCode = this.getCurrentCode(this.Movement.Current)

      if (currentCode == null || currentCode == '') {
        this.text1 = this.$t('Please-choose')
        this.snackbar = true
        return
      }

      if (this.Movement.Amount == null || Number(this.Movement.Amount) <= 0) {
        this.text1 = this.$t('Please-enter-amount-v2')
        this.snackbar = true
        return
      }

      if (this.Movement.ExchangeType == null || this.Movement.ExchangeType == '') {
        if (credentials.ParaBirimi == 'TRY' || credentials.ParaBirimi == null || credentials.ParaBirimi == '') {
          this.Movement.ExchangeType = 'TL'
        } else {
          this.Movement.ExchangeType = credentials.ParaBirimi
        }

        this.Movement.ExchangeRate = 1
        this.Movement.ExchangeAmount = this.Movement.Amount * 1
      }

      this.operationTypeChanged()
      this.paymentMethodChanged()

      var currentMovement = JSON.parse(JSON.stringify(this.Movement))
      currentMovement.CompanyCode = credentials.SirketKodu
      currentMovement.Current = currentCode
      currentMovement.DocumentNumber = null
      currentMovement.GrossAmount = this.Movement.Amount
      currentMovement.DiscountAmount = 0
      currentMovement.TaxAmount = 0
      currentMovement.TaxRate = 0

      if (!this.extraOptionsOpen) {
        currentMovement.Reference = null
        currentMovement.ExpenseCenter = null
        currentMovement.ContraAccount = null
      }

      this.saveLoading = true

      this.$http.post(auth.API_URL + 'api/CurrentMovement/New', currentMovement, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.saveLoading = false

        this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true

        if (response.body.Status == true) {
          var sirano = null

          if (response.body.CariResponse && response.body.CariResponse.Sirano) {
            sirano = response.body.CariResponse.Sirano
          }

          var pdfParams = {
            CompanyCode: credentials.SirketKodu,
            Date: this.Movement.MovementDate,
            AccountCode: currentCode,
            OrderNumber: sirano
          }

          this.closeEntryDialog()
          this.CarihareketGetir()

          if (downloadAfterSave == true && sirano != null) {
            this.downloadReceiptPdf(pdfParams, currentMovement.DebitCredit)
          }
        }
      }, (response) => {
        this.saveLoading = false

        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
        } else if (response.body && response.body.ExceptionMessage) {
          this.text1 = response.body.ExceptionMessage
        } else {
          this.text1 = 'Service Unavailable'
        }

        this.snackbar = true
      })
    },

    downloadReceiptPdfFromRow(item) {
  var credentials = JSON.parse(
    window.localStorage.getItem('credentials')
  )

  if (
    !item ||
    !item.Cari ||
    !item.Cari.Kod ||
    !item.Tarih ||
    !item.Sirano
  ) {
    this.text1 =
      'Makbuz indirmek için cari kodu, tarih ve sıra no bilgisi gerekli.'

    this.snackbar = true
    return
  }

  var params = {
    CompanyCode: credentials.SirketKodu,
    Date: item.Tarih,
    AccountCode: item.Cari.Kod,
    OrderNumber: item.Sirano
  }

  this.downloadReceiptPdf(params, item.BA)
},

downloadReceiptPdf(params, ba) {
  if (!params) {
    this.text1 = 'Makbuz PDF bilgileri bulunamadı.'
    this.snackbar = true
    return
  }

  this.pendingReceiptPdfParams =
    JSON.parse(JSON.stringify(params))

  this.pendingReceiptBa = ba

  /*
   * Dialog her açıldığında varsayılan olarak
   * Türkçe seçilir.
   */
  this.receiptLanguage = 'tr'
  this.receiptLanguageDialog = true
},

cancelReceiptLanguageDialog() {
  if (this.progress) {
    return
  }

  this.receiptLanguageDialog = false
  this.pendingReceiptPdfParams = null
  this.pendingReceiptBa = null
  this.receiptLanguage = 'tr'
},

confirmReceiptPdfDownload() {
  if (!this.pendingReceiptPdfParams) {
    this.text1 = 'Makbuz PDF bilgileri bulunamadı.'
    this.snackbar = true
    this.receiptLanguageDialog = false
    return
  }

  var params = JSON.parse(
    JSON.stringify(this.pendingReceiptPdfParams)
  )

  params.Lang = this.receiptLanguage || 'tr'

  var ba = this.pendingReceiptBa

  this.downloadReceiptPdfNow(params, ba)
},

downloadReceiptPdfNow(params, ba) {
  this.progress = true

  this.$http.post(
    auth.API_URL + 'api/CurrentMovement/ReceiptPdf',
    params,
    {
      headers: {
        'Authorization':
          'Bearer ' + auth.getAuthHeader()
      },
      responseType: 'blob'
    }
  ).then((response) => {
    this.progress = false
    this.receiptLanguageDialog = false

    var blob = new Blob(
      [response.body],
      {
        type: 'application/pdf'
      }
    )

    var blobUrl =
      window.URL.createObjectURL(blob)

    var link =
      document.createElement('a')

    link.href = blobUrl

    link.download =
      this.getReceiptPdfFileName(
        ba,
        params.Lang
      )

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(blobUrl)

    this.pendingReceiptPdfParams = null
    this.pendingReceiptBa = null
  }, (response) => {
    this.progress = false

    if (
      response &&
      response.body &&
      response.body.ExceptionMessage
    ) {
      this.text1 =
        response.body.ExceptionMessage
    } else {
      this.text1 =
        'Makbuz PDF indirilemedi.'
    }

    this.snackbar = true
  })
},

getReceiptPdfFileName(ba, lang) {
  var isCollection = ba == 'A'

  if (lang == 'en') {
    return isCollection
      ? 'CollectionReceipt.pdf'
      : 'PaymentReceipt.pdf'
  }

  if (lang == 'de') {
    return isCollection
      ? 'Zahlungseingangsbeleg.pdf'
      : 'Zahlungsausgangsbeleg.pdf'
  }

  if (lang == 'fr') {
    return isCollection
      ? 'RecuEncaissement.pdf'
      : 'RecuPaiement.pdf'
  }

  return isCollection
    ? 'TahsilatMakbuzu.pdf'
    : 'TediyeMakbuzu.pdf'
},

    editMovement(item) {
      if (!item || !item.Cari || !item.Cari.Kod || !item.Tarih || !item.Sirano) {
        this.text1 = 'Düzenleme için cari kodu, tarih ve sıra no bilgisi gerekli.'
        this.snackbar = true
        return
      }

      var url =
        '#/carihareketler/duzenle/id?' +
        'ac=' + encodeURIComponent(item.Cari.Kod) +
        '&dt=' + encodeURIComponent(item.Tarih) +
        '&on=' + encodeURIComponent(item.Sirano)

      window.open(url, '_blank')
    },

    openChangeLog(item) {
      var credentials = JSON.parse(localStorage.getItem('credentials'))

      if (!item || !item.Cari || !item.Cari.Kod || !item.Tarih || !item.Evrakno) {
        this.text1 = 'Log için cari kodu, tarih ve evrak no bilgisi gerekli.'
        this.snackbar = true
        return
      }

      var params = {
        CompanyCode: credentials.SirketKodu,
        Current: item.Cari.Kod,
        MovementDate: item.Tarih,
        EvrakNo: item.Evrakno
      }

      this.$http.post(auth.API_URL + 'api/CurrentMovement/GetChangeLog', params, {
        headers: {
          Authorization: 'Bearer ' + auth.getAuthHeader()
        }
      }).then((res) => {
        this.changeLogs = res.body
        this.logDialog = true
      }, () => {
        this.text1 = 'Log kayıtları alınamadı.'
        this.snackbar = true
      })
    },

    filtrekayit() {
      this.filtrevarmi = true
      this.dialogfiltre = false
      this.CarihareketGetir()
    },

    filtreiptal() {
      this.filtrevarmi = false
      this.dialogfiltre = false
      this.CariHareketInput.BiletHaric = false
      this.CariHareketInput.CariKodu = null
      this.CariHareketInput.Filtreler.Referans = null
      this.CariHareketInput.Filtreler.Masraf = null
      this.CariHareketInput.Filtreler.BaslangicTutar = 0
      this.CariHareketInput.Filtreler.BitisTutar = 0
      this.CariHareketInput.Filtreler.EvrakNo = null
      this.CariHareketInput.Filtreler.EvrakTipi = null
      this.CariHareketInput.Filtreler.FaturaNo = null
      this.CariHareketInput.Entegre = false
      this.CariHareketInput.ListTipi = 0

      this.CarihareketGetir()
    },

    CarihareketGetir() {
      this.dialogfiltre = false

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih > bittarih) {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
        return
      }

      var credentials = JSON.parse(window.localStorage.getItem('credentials'))

      if (this.date == null) {
        this.date = this.getDateNow()
      }

      if (this.date2 == null) {
        this.date2 = this.getDateNow()
      }

      this.CariHareketInput.BaslangicTarihi = this.date
      this.CariHareketInput.BitisTarihi = this.date2
      this.CariHareketInput.SirketKodu = credentials.SirketKodu
      this.CariHareketInput.Filtreler.Referans = null
      this.CariHareketInput.Filtreler.Masraf = null

      this.progress = true
      this.load1 = false
      this.load = true

      var Params = this.CariHareketInput

      this.$http.post(auth.API_URL + 'api/movement/index', Params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.rawItems = response.body || []
        this.progress = false
        this.load1 = true
        this.load = false
      }, (response) => {
        this.progress = false
        this.load1 = true
        this.load = false

        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
        } else {
          this.text1 = response.statusText || 'Service Unavailable'
        }

        this.snackbar = true
      })
    },

    loadDefinitions() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'))
      var params = {
        CompanyCode: credentials.SirketKodu
      }

      this.$http.post(auth.API_URL + 'api/doctype/List', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.evraktipi = response.body || []
      })

      this.$http.post(auth.API_URL + 'api/currency/List', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.doviztipi = response.body || []
      })

      this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.bankapositems = response.body || []
      })
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.path
    })
  },

  mounted() {
    this.simpleModeYukle()

    if (this.$refs.fab && this.$refs.fab.$el) {
      this.el = this.$refs.fab.$el
    }

    var credentials = JSON.parse(window.localStorage.getItem('credentials'))

    this.date = this.getDateNow()
    this.date2 = this.getDateNow()
    this.CariHareketInput.BaslangicTarihi = this.date
    this.CariHareketInput.BitisTarihi = this.date2
    this.CariHareketInput.SirketKodu = credentials.SirketKodu

    this.loadDefinitions()
    this.CarihareketGetir()
  },

  components: {
    parainput,
    tarihim,
    cariaracomp,
    snackbarcomp,
    bankakodu,
    kredikartcomp,
    masrafmerkezicomp,
    referansmerkezicomp,
    muhasebekoducomp,
    SimpleTahsilatOdemeDialog,
    ReceiptPdfSettingsDialog
  }
}
</script>

<style scoped>
.action-cell {
  white-space: nowrap;
}

.modern-payment-dialog {
  background: #f6f8fb;
  border-radius: 14px;
}

.modern-dialog-header {
  padding: 20px 24px;
  background: #ffffff;
}

.modern-dialog-body {
  padding: 20px 24px;
  background: #f6f8fb;
}

.modern-dialog-actions {
  padding: 14px 24px;
  background: #ffffff;
}

.modern-section-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 18px;
  margin-bottom: 14px;
  box-shadow: 0 2px 10px rgba(20, 35, 60, 0.08);
}

.modern-section-title {
  font-size: 15px;
  font-weight: 700;
  color: #263238;
}

.modern-section-subtitle {
  font-size: 12px;
  color: #78909c;
  margin-top: 3px;
}

.modern-toggle-group {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.modern-operation-item {
  min-width: 150px;
  padding: 12px 16px;
  border-radius: 12px;
  background: #f4f6f8;
  color: #607d8b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  transition: all 0.18s ease;
}

.modern-operation-item:hover {
  background: #e3f2fd;
  color: #1976d2;
}

.modern-operation-item-active {
  background: #1976d2;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(25, 118, 210, 0.25);
}

.modern-operation-item-active .v-icon {
  color: #ffffff !important;
}

.modern-payment-method-card {
  min-height: 92px;
  border-radius: 14px;
  padding: 16px;
  margin: 6px;
  background: #f8fafc;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.18s ease;
  border: 1px solid transparent;
}

.modern-payment-method-card .v-icon {
  font-size: 32px;
  color: #78909c;
}

.modern-payment-method-card:hover {
  background: #eef6ff;
  border-color: #bbdefb;
  transform: translateY(-1px);
}

.modern-payment-method-card-active {
  background: #e3f2fd;
  border-color: #1976d2;
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.18);
}

.modern-payment-method-card-active .v-icon {
  color: #1976d2 !important;
}

.modern-payment-title {
  font-size: 15px;
  font-weight: 700;
  color: #263238;
}

.modern-payment-subtitle {
  font-size: 12px;
  color: #78909c;
  margin-top: 3px;
}

.modern-extra-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.modern-extra-content {
  margin-top: 16px;
}

.fill-height {
  height: 100%;
}

.my-3 {
  margin-top: 12px;
  margin-bottom: 12px;
}

.mt-3 {
  margin-top: 12px;
}

.mb-2 {
  margin-bottom: 8px;
}

.mb-3 {
  margin-bottom: 12px;
}

@media (max-width: 768px) {
  .modern-toggle-group {
    justify-content: flex-start;
    margin-top: 12px;
  }

  .modern-operation-item {
    min-width: auto;
    flex: 1;
  }

  .modern-payment-method-card {
    min-height: 76px;
  }
}
</style>